export default __webpack_public_path__ + "static/media/uploader-ascensiaContour-problem-2.beff8297.png";